import { IncidentModel } from './incident.model';

export class NsfIncidentModel extends IncidentModel {
    public incidentNSFId = 0;
    public customerOutstandingBalanceId = 0;
    public checkNumber: string;
    public checkAmount: string;
}
